import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { CitationViewDialogComponent } from "../../citation-management/citation-view-dialog/citation-view-dialog.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { LprCameraGroupService } from "src/app/services/lpr-camera-group.service";
import { first } from "rxjs/operators";
import { WebConstants } from "src/app/util/web.constants";
import { Lookup } from "src/app/model/lookup";
import { ToastrService } from "ngx-toastr";
import { UserService } from "src/app/services/user.service";
import { EnforcementVehicleService } from "src/app/services/enforcement-vehicle.service";

@Component({
  selector: "app-vehicle-add-dialog",
  templateUrl: "./vehicle-add-dialog.component.html",
  styleUrls: ["./vehicle-add-dialog.component.scss"],
})
export class VehicleAddDialogComponent implements OnInit {
  public form: any;
  public cameraGroupList: Lookup[] = [];
  public userList: Lookup[] = [];

  constructor(
    public dialog: MatDialogRef<CitationViewDialogComponent>,
    public lprCameraGroupService: LprCameraGroupService,
    public toastrService: ToastrService,
    public userService: UserService,
    public enforcementVehicleService: EnforcementVehicleService,
  ) {}

  ngOnInit(): void {
    this.getAllGroups();
    this.getAllUsers();
    this.initlizeVehicleAddForm();
  }

  initlizeVehicleAddForm(): void {
    this.form = new FormGroup({
      name: new FormControl("", Validators.required),
      make: new FormControl("", Validators.required),
      model: new FormControl("", Validators.required),
      variant: new FormControl("", Validators.required),
      color: new FormControl("", Validators.required),
      lpn: new FormControl("", Validators.required),
      peoId: new FormControl("", Validators.required),
      cameraGroupId: new FormControl("", Validators.required),
    });
  }

  closeDialog(): void {
    this.dialog.close();
  }

  getAllGroups() {
    this.lprCameraGroupService
      .getAllLprCameraGroup()
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.cameraGroupList = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  getAllUsers(): void {
    this.userService
      .getAll()
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.userList = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  addVehicle(): void {
    let data = this.form.getRawValue();

    this.enforcementVehicleService.addVehicle(data)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Vehicle Added Successfully!");
          this.dialog.close(true);
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      });
  }
}
